import { Injectable, signal } from '@angular/core';

export interface ConfirmRequest {
  title: string;
  message: string;
  confirmLabel: string;
  danger: boolean;
  resolve: (accepted: boolean) => void;
}

/** Promise-based confirm dialog (replaces PrimeNG ConfirmationService).
 *  A single host in the shell renders the active request. */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  readonly active = signal<ConfirmRequest | null>(null);

  confirm(options: { title?: string; message: string; confirmLabel?: string; danger?: boolean }): Promise<boolean> {
    return new Promise((resolve) => {
      this.active.set({
        title: options.title ?? 'Are you sure?',
        message: options.message,
        confirmLabel: options.confirmLabel ?? 'Confirm',
        danger: options.danger ?? false,
        resolve,
      });
    });
  }

  decide(accepted: boolean): void {
    const req = this.active();
    this.active.set(null);
    req?.resolve(accepted);
  }
}
